import { render, staticRenderFns } from "./StatichtmlWidget.vue?vue&type=template&id=d8048062"
import script from "./StatichtmlWidget.vue?vue&type=script&lang=js"
export * from "./StatichtmlWidget.vue?vue&type=script&lang=js"
import style0 from "./StatichtmlWidget.vue?vue&type=style&index=0&id=d8048062&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports